import React from "react";
import { Link } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
import SupportSEO from "../../components/Support/SupportSEO";
import ZohoWidget from "../../components/ZohoWidget";

const compactLink =
  "inline-flex items-center justify-center px-3 py-2 text-sm text-brand-charcoal bg-brand-cream font-display font-bold tracking-wide border border-brand-charcoal/20 rounded-lg hover:border-brand-gold-ink";

const Contact = () => {
  return (
    <>
      <SupportSEO
        title="Contact Support - Bowling Tournament Help"
        description="Submit a support ticket through our integrated Zoho Desk widget for bowling tournament management assistance."
        keywords={[
          "contact support",
          "bowling tournament help",
          "support team",
          "customer service",
          "support ticket",
        ]}
        canonicalUrl="/support/contact"
      />
      <div className="min-h-screen bg-brand-cream py-8">
        <div className="max-w-4xl mx-auto px-4">
          <div className="card-board overflow-hidden mb-6">
            <div className="bg-brand-charcoal text-brand-cream px-6 py-4">
              <h1 className="font-display font-bold text-xl md:text-2xl text-brand-cream tracking-tight">
                Contact Support
              </h1>
              <p className="text-sm text-brand-mist mt-1">
                Submit a ticket. We answer within 48 hours.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            <div className="lg:col-span-1 order-2 lg:order-1">
              <div className="card-inset p-4 lg:p-6">
                <h3 className="heading-display text-lg mb-3">
                  Before you submit
                </h3>
                <ul className="space-y-2 text-sm text-brand-charcoal">
                  <li>
                    Check the{" "}
                    <Link to="/support" className="text-brand-gold-ink underline hover:text-brand-charcoal">
                      Help
                    </Link>{" "}
                    pages first
                  </li>
                  <li>Have your account information ready</li>
                  <li>Include screenshots for technical issues</li>
                  <li>Provide specific details about the problem</li>
                  <li>Response time: within 48 hours</li>
                </ul>
              </div>
            </div>

            <div className="lg:col-span-2 order-1 lg:order-2">
              <div className="card-board p-4 lg:p-8">
                <h2 className="heading-display text-lg mb-4">
                  Submit a Support Ticket
                </h2>
                <div className="py-2 lg:py-4">
                  <ZohoWidget />
                </div>
              </div>
            </div>
          </div>

          <div className="text-center mt-8">
            <Link to="/support" className={compactLink}>
              <FiArrowLeft className="mr-2" />
              Back to Help
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
